(function (ng) {
    

    angular.module('input', []);
})(window.angular);
